import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { ProgressComponent } from 'src/app/shared/components/dialog/progress.component';

export interface ProgressRef {
  close(): void;
}

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  constructor(
    private readonly _overlay: Overlay
  ) { }

  /**
   * ローディング開始
   */
  show(): ProgressRef {
    const portal = new ComponentPortal(ProgressComponent);
  
    const overlayRef = this._createOverlay();
    overlayRef.attach(portal);
  
    return {
      // ローディング終了
      close() {
        overlayRef.detach();
        overlayRef.dispose();
      }
    };
  }
  
  /**
   * オーバーレイ生成
   */
  private _createOverlay(): OverlayRef {
    return this._overlay.create({
      width: '100%',
      height: '100%',
      hasBackdrop: true,
      panelClass: 'app-loading-indicator',
      backdropClass: 'app-loading-indicator-backdrop',
    });
  }
  
}